import * as Styles from './styles'

const StatsInfo = ({
  backgroundColor,
  icon,
  backgroundIcon,
  colorIcon,
  label,
  info,
  orientation = 'column',
  onClick,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <Styles.Container
      backgroundColor={backgroundColor}
      orientation={orientation}
      onClick={handleClick}
      clickable={onClick}
    >
      <Styles.IconAndLabelContainer>
        <Styles.IconContainer backgroundIcon={backgroundIcon} colorIcon={colorIcon}>
          {icon}
        </Styles.IconContainer>
        {label}
      </Styles.IconAndLabelContainer>
      {info}
    </Styles.Container>
  )
}

export default StatsInfo
